const photos = [
    {
        name: 'photo1',
        title: 'Frankfurt Hauptbahnhof',
        content: [
            'A view of Frankfurt\'s main railway station canopy.'
        ],
        image: <img src='/images/frankfurt1.jpg' alt='Frankfurt station platform area.'></img>
    },
    {
        name: 'photo2',
        title: 'Roma Termini',
        content: [
            'Italian high speed train rests at Rome\'s main rail station.'
        ],
        image: <img src='/images/roma_termini1.jpg' alt='Rome station platform area.'></img>
    },
    {
        name: 'photo3',
        title: 'Madrid Chamartin',
        content: [
            'A RENFE Avante train after arrival from Segovia.'
        ],
        image: <img src='/images/renfe_avant.jpg' alt='Madrid station platform area.'></img>
    }
];

export default photos;